import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadFileService } from 'src/app/_services/UploadFile/upload-file.service';


@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {
  @Input() label: string = '';
  @Input() images: string[] = [];
  @Output() imagesChange = new EventEmitter<string[]>();

   constructor(private uploadService: UploadFileService) {}

  onFileSelected(event: any) {
    const files: File[] = event.target.files;
    if (!files?.length) return;

    Array.from(files).forEach(file => {
      const formData = new FormData();
      formData.append('fileData', file);

      this.uploadService.uploadSingleFile(formData).subscribe({
        next: (res: any) => {
          const fileUrl = res[0]?.file_Path;
          if (fileUrl) {
            this.images.push(fileUrl);
            this.imagesChange.emit(this.images); // emit back to parent
          }
        },
        error: (err) => console.error('Upload failed', err)
      });
    });
  }

  removeImage(url: string) {
    this.images = this.images.filter(img => img !== url);
    this.imagesChange.emit(this.images);
  }
}
